import { useState, useEffect, ReactElement } from 'react';

type Props = {
    text: string;
    speed?: number;
};

const TypewriterText = ({ text, speed = 50 }: Props): ReactElement => {
    const [displayedText, setDisplayedText] = useState('');

    useEffect(() => {
        let index = 0;
        setDisplayedText('');

        const intervalId = setInterval(() => {
            setDisplayedText((prev) => text.slice(0, index + 1));
            index++;

            if (index >= text.length) {
                clearInterval(intervalId);
            }
        }, speed);

        return () => clearInterval(intervalId);
    }, [text, speed]);

    return <span>{displayedText}</span>;
};

export default TypewriterText;
